import { render, staticRenderFns } from "./AddComponents.vue?vue&type=template&id=d8e1b42e&"
import script from "./AddComponents.vue?vue&type=script&lang=js&"
export * from "./AddComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports